function getUa() {
    const ua = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
    ) ||
    window.screen.width < 500;;
    return ua;
}

/**
 * 移动设备检测
 * @ref http://stackoverflow.com/questions/3514784/what-is-the-best-way-to-detect-a-mobile-device-in-jquery/3540295#3540295
 * @returns {boolean}
 */
function mobilecheck() {
    return getUa();
}

// 添加判断方法
function isMobile() {
    if (getUa()) {
        console.log('移动端打开');
        document.getElementsByTagName('body')[0].className = 'h5Style';
        return true;
    } else {
        console.log('PC端打开');
        document.getElementsByTagName('body')[0].className = 'pcStyle';
        return false;
    }
}

export {
    isMobile,
    getUa,
    mobilecheck,
};
